export default function interiorBgInit() {
    $(document).ready(function () {
        $(".bg-top-interior").addClass("expand");
    });

    // Random interior header bg image
    $(document).ready(function () {
        var classes = ["bg-header-1", "bg-header-2", "bg-header-3", "bg-header-4"];
        var randomnumber = Math.floor(Math.random() * classes.length);

        $(".bg-top-interior").addClass(classes[randomnumber]);
    });
}
